import { Trans } from "@lingui/react/macro";
import React from "react";
import { Link } from "react-router";
import { RightOutlined } from "@ant-design/icons";

import { ContentWidth } from "../../lib/ui-components/layout/content-width";
import { Heading1, Heading2 } from "../../styles/typography";
import { useUser } from "../../lib/contexts/user";
import colors from "../../styles/colors";
import { OrganizationSwitcher } from "../../lib/ui-components/layout/organization-select";

export function Home() {
  const { user } = useUser();
  const username = user!.name ?? user!.email!;

  return (
    <ContentWidth width="small" className="pt-16 flex flex-col gap-6">
      <Heading1>
        <Trans>Welcome {username}!</Trans>
      </Heading1>
      <div>
        <p className="text-secondary">
          <Trans>Current organization:</Trans>
        </p>
        <Heading2>
          <OrganizationSwitcher className="max-w-full" />
        </Heading2>
      </div>
      <div className="flex flex-row gap-6 pt-2 flex-wrap">
        <Link to="../energy-overview">
          <div className="flex flex-row gap-4 bg-white p-4 items-center">
            <svg className="h-8" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="12.1133" width="8" height="19.8867" fill={colors.aqua["300"]} />
              <rect x="12.5" width="8" height="32" fill={colors.aqua["500"]} />
              <rect x="24.5" y="6.58984" width="8" height="25.4102" fill={colors.aqua["700"]} />
            </svg>

            <Heading2>
              <Trans>Energy Management</Trans>
            </Heading2>
            <RightOutlined />
          </div>
        </Link>
        <Link to="../carbon">
          <div className="flex flex-row gap-4 bg-white p-4 items-center">
            <svg className="h-8" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.18049 20.6177C2.01797 23.3969 3.59565 25.8959 5.74456 27.8471C7.89347 29.7983 10.5327 31.1283 13.3795 31.6945L14.9414 23.8421C13.519 23.5592 12.2003 22.8947 11.1266 21.9198C10.0529 20.9449 9.26467 19.6963 8.84623 18.3077L1.18049 20.6177Z"
                fill={colors.aqua["300"]}
              />
              <path
                d="M32.502 16.001C32.502 13.6889 32.0009 11.4044 31.0333 9.30455C30.0657 7.20472 28.6546 5.33952 26.897 3.83737C25.1395 2.33521 23.0772 1.23177 20.8524 0.603029C18.6275 -0.0257149 16.2927 -0.164832 14.0089 0.195255C11.7251 0.555342 9.54643 1.40608 7.62292 2.6889C5.69942 3.97172 4.07676 5.65614 2.86666 7.62621C1.65657 9.59627 0.887776 11.8052 0.613221 14.1009C0.338666 16.3965 0.564868 18.7244 1.27625 20.9243L8.89253 18.4614C8.53702 17.362 8.42398 16.1986 8.56119 15.0514C8.69839 13.9042 9.08259 12.8003 9.68733 11.8157C10.2921 10.8312 11.103 9.98944 12.0642 9.34836C13.0255 8.70728 14.1143 8.28213 15.2556 8.10218C16.3969 7.92223 17.5637 7.99175 18.6755 8.30596C19.7874 8.62017 20.818 9.17161 21.6963 9.9223C22.5747 10.673 23.2799 11.6051 23.7634 12.6545C24.247 13.7039 24.4973 14.8456 24.4973 16.001H32.502Z"
                fill={colors.aqua["500"]}
              />
              <path
                d="M12.7068 31.5456C15.0617 32.1204 17.5163 32.1526 19.8854 31.6399C22.2546 31.1272 24.4763 30.0829 26.3827 28.586C28.2892 27.089 29.8307 25.1784 30.8907 22.9985C31.9508 20.8186 32.5017 18.4264 32.502 16.0024L24.5064 16.0017C24.5063 17.2144 24.2307 18.4113 23.7003 19.5019C23.17 20.5926 22.3988 21.5484 21.4449 22.2974C20.4911 23.0463 19.3796 23.5688 18.1943 23.8253C17.009 24.0818 15.7809 24.0657 14.6027 23.7781L12.7068 31.5456Z"
                fill={colors.aqua["700"]}
              />
            </svg>

            <Heading2 className="">
              <Trans>CO₂ Management</Trans>
            </Heading2>
            <RightOutlined />
          </div>
        </Link>
      </div>
    </ContentWidth>
  );
}

export default Home;
